(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/use-current-date-draws.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/use-current-date-draws.js');
"use strict";

const {
  EngineProviderContext
} = svs.components.tipsen.engine;
const tipsenApi = svs.components.tipsen.store.tipsenApi;
const {
  DrawState,
  getDrawStateEnum,
  drawStateEnums
} = svs.components.sport.tipsenShared;
const {
  useContext,
  useRef
} = React;
const useCurrentDateDraws = (year, month, currentDate, hasDateParam) => {
  var _dateResult$current;
  const {
    currentEngine
  } = useContext(EngineProviderContext);
  const dateResult = useRef();
  const {
    data,
    isLoading,
    error
  } = tipsenApi.useGetResultDatePickerQuery({
    year,
    month,
    product: currentEngine.loadDrawsApiPath
  });
  dateResult.current = data;
  let currentDateDraws = [];
  let latestFinalizedDateObj;
  const fetchedDates = data === null || data === void 0 ? void 0 : data.resultDates;
  if (dateResult !== null && dateResult !== void 0 && (_dateResult$current = dateResult.current) !== null && _dateResult$current !== void 0 && _dateResult$current.resultDates) {
    let latestFinalizedResults = dateResult.current.resultDates.filter(resultDate => getDrawStateEnum(resultDate.drawStateId) === drawStateEnums.LIVE);
    if (latestFinalizedResults.length === 0) {
      latestFinalizedResults = dateResult.current.resultDates.filter(resultDate => resultDate.drawStateId === DrawState.Finalized);
    }
    if (latestFinalizedResults.length === 0) {
      latestFinalizedResults = dateResult.current.resultDates;
    }
    if (latestFinalizedResults.length > 0) {
      latestFinalizedDateObj = new Date(latestFinalizedResults[0].date);
    }

    const compareDate = hasDateParam ? currentDate : latestFinalizedDateObj;
    currentDateDraws = dateResult.current.resultDates.filter(resultDate => dateFns.isSameDay(new Date(resultDate.date), compareDate));
  }
  return [currentDateDraws, isLoading, fetchedDates, latestFinalizedDateObj, error];
};
setGlobal('svs.components.tipsen.routeResult.useCurrentDateDraws', useCurrentDateDraws);

 })(window);